import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './Disable2fa.css';

const Disable2fa: React.FC = () => {
  const navigate = useNavigate();
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);

  const handleBack = () => {
    navigate('/profile-security');
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();

    if (!password) {
      return;
    }

    setIsSubmitting(true);

    // Simulate API call
    setTimeout(() => {
      setIsSubmitting(false);
      setShowSuccessModal(true);
    }, 1500);
  };

  const handleCloseModal = () => {
    setShowSuccessModal(false);
    navigate('/profile-security');
  };

  const isFormValid = password.length > 0;

  return (
    <div className="disable2fa-container">
      {/* Header */}
      <header className="disable2fa-header">
        <button className="disable2fa-back-btn" onClick={handleBack} aria-label="Go back">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M10 12L6 8L10 4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </button>
        <h1 className="disable2fa-title">Disable 2FA</h1>
      </header>

      {/* Content */}
      <div className="disable2fa-content">
        <p className="disable2fa-description">
          To Disable 2FA, please provide your password
        </p>

        <form onSubmit={handleSubmit} className="disable2fa-form">
          {/* Password Input Card */}
          <div className="disable2fa-input-card">
            <div className="disable2fa-input-wrapper">
              <input
                type={showPassword ? 'text' : 'password'}
                className="disable2fa-input"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••••••••••••••"
                autoComplete="current-password"
              />
              <button
                type="button"
                className="disable2fa-visibility-btn"
                onClick={() => setShowPassword(!showPassword)}
                aria-label={showPassword ? 'Hide password' : 'Show password'}
              >
                {showPassword ? (
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <path d="M1.33334 8.00001C1.33334 8.00001 3.33334 3.33334 8.00001 3.33334C12.6667 3.33334 14.6667 8.00001 14.6667 8.00001C14.6667 8.00001 12.6667 12.6667 8.00001 12.6667C3.33334 12.6667 1.33334 8.00001 1.33334 8.00001Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M8 10C9.10457 10 10 9.10457 10 8C10 6.89543 9.10457 6 8 6C6.89543 6 6 6.89543 6 8C6 9.10457 6.89543 10 8 10Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                ) : (
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <path d="M9.41334 9.41334C9.23024 9.60983 9.00944 9.76744 8.76411 9.87686C8.51878 9.98629 8.25394 10.0454 7.98541 10.0507C7.71688 10.056 7.44992 10.0074 7.20049 9.90755C6.95106 9.80771 6.72426 9.65869 6.53279 9.46722C6.34132 9.27575 6.1923 9.04895 6.09246 8.79952C5.99261 8.55009 5.94406 8.28313 5.94934 8.0146C5.95461 7.74607 6.01372 7.48123 6.12315 7.2359C6.23257 6.99057 6.39018 6.76977 6.58667 6.58667M11.96 11.96C10.8204 12.8287 9.43275 13.3099 8.00001 13.3333C3.33334 13.3333 1.33334 8.00001 1.33334 8.00001C2.16289 6.45462 3.31824 5.10441 4.72001 4.04001L11.96 11.96ZM6.60001 2.82667C7.05889 2.71926 7.52871 2.66556 8.00001 2.66667C12.6667 2.66667 14.6667 8.00001 14.6667 8.00001C14.2608 8.75708 13.7637 9.4698 13.1867 10.12L6.60001 2.82667Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M1.33334 1.33334L14.6667 14.6667" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                )}
              </button>
            </div>
          </div>

          {/* Submit Button */}
          <button
            type="submit"
            className={`disable2fa-submit-btn ${!isFormValid || isSubmitting ? 'disabled' : ''}`}
            disabled={!isFormValid || isSubmitting}
          >
            {isSubmitting ? 'Disabling...' : 'Disable 2FA'}
          </button>
        </form>
      </div>

      {/* Success Modal */}
      {showSuccessModal && (
        <div className="disable2fa-modal-overlay" onClick={handleCloseModal}>
          <div className="disable2fa-modal-dialog" onClick={(e) => e.stopPropagation()}>
            {/* Success Icon */}
            <div className="disable2fa-modal-icon">
              <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
                <path d="M40 14L18 36L8 26" stroke="currentColor" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>

            {/* Title */}
            <h2 className="disable2fa-modal-title">Success!</h2>

            {/* Message */}
            <p className="disable2fa-modal-message">
              2FA has been disabled successfully
            </p>

            {/* Close Button */}
            <button className="disable2fa-modal-btn" onClick={handleCloseModal}>
              Close
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Disable2fa;
